import React, { Component } from 'react';
import Select from 'react-select';

class HierarchyFieldSelectorItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      value: null,
    };
  }

  loadData(parent, value) {
    let stateValue, stateOptions, endpoint;

    if (this.props.opened.indexOf(this.props.data.level) > -1) {
      endpoint = !parent ? 'roots' : `${parent}/children`;
      $.getJSON(`/${currentCustomer}/hierarchy_fields/${endpoint}`).done(
        (data) => {
          try {
            stateValue = typeof value === 'undefined' ? '' : value;
            stateOptions = data.map((n) => {
              return { label: n.name, value: n.id };
            });
          } catch {
            stateValue = '';
            stateOptions = [];
          } finally {
            this.setState({ value: stateValue, options: stateOptions });
          }
        },
      );
    }
  }

  handleChange(val) {
    this.setState({ value: val });
    this.props.handleLevelChange(val, this.props.data);
  }

  render() {
    return (
      <If condition={this.props.opened.indexOf(this.props.data.level) > -1}>
        <Select
          className='HierarchyFieldSelectorItem'
          crealabre='true'
          name={this.props.data.name}
          options={this.state.options}
          placeholder={this.props.data.name}
          value={this.state.value}
          onChange={this.handleChange.bind(this)}
        />
      </If>
    );
  }
}

module.exports = HierarchyFieldSelectorItem;
